import { fromJS } from 'immutable';
import { instance } from '../api/transport';

// The Immutable adapter on api/transport for the redux ducks and sagas: every
// success resolves as fromJS({ headers, data }) — the raw axios headers, so a
// browser response yields a List of [name, value] pairs and a plain-object
// one a Map — and every failure rejects with the transport's ApiError.
// New code reads plain data through `http` in src/api instead.

export { getServerOrigin, REQUEST_TIMEOUT_MS } from '../api/transport';

/** @returns {Promise<any>} */
const wrap = (request) =>
  request.then((response) =>
    fromJS({ headers: response.headers, data: response.data }),
  );

const client = {
  /** @returns {Promise<any>} */
  get: (url, config) => wrap(instance.get(url, config)),
  /** @returns {Promise<any>} */
  post: (url, data, config) => wrap(instance.post(url, data, config)),
  /** @returns {Promise<any>} */
  patch: (url, data, config) => wrap(instance.patch(url, data, config)),
  /** @returns {Promise<any>} */
  put: (url, data, config) => wrap(instance.put(url, data, config)),
  /** @returns {Promise<any>} */
  delete: (url, config) => wrap(instance.delete(url, config)),
};

export default client;
